import React, { useState, useEffect, useContext, Fragment } from "react";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { toast } from "react-toastify";

const ApproveRejectList = ({
  getoffRoleEmployeesData,
  getEmployeesListing = [],
  getDataForDropdown,
  getDropdownDatas = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [roleId, setRoleId] = useState("");

  const Headers = [
    "Request ID",
    "Department",
    "Employee Name",
    "Request Date",
    "Vendor",
    "Employee Type",
    "Hiring Location",
    "Status",
    "Action",
  ];

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getDataForDropdown();
      const res = await getoffRoleEmployeesData(1, [2, 5]);
      if (res?.data?.response_status !== 200) {
        toast.error(res?.data?.message);
      }
      setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const tableData = [
      "id",
      "request_id",
      "department_name",
      "employee_name",
      "requested_date",
      "vendor_name",
      "employee_type_name",
      "city_name",
      "status_name",
    ];

    setListData();

    if (
      getEmployeesListing &&
      getEmployeesListing?.response?.data &&
      getEmployeesListing?.response?.data?.data
    ) {
      const data = getEmployeesListing?.response?.data?.data?.map((element) => {
        let actions = [];

        if (element.status === 5) {
          actions.push({
            name: "Approve/Reject",
            link: `${baseUrl}/approve-reject-employee-request`,
          });
        }
        return Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          { Action: element.status === 2 ? null : actions }
        );
      });

      if (data) setListData(data);
      setPageCount(
        Math.ceil(
          getEmployeesListing?.response?.data?.total /
            getEmployeesListing?.response?.data?.to
        )
      );
    }
  }, [getEmployeesListing]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("getoffRoleEmployeesData", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    const res = await getoffRoleEmployeesData(1, [5, 2], null, filterData);
    if (res?.data?.response_status !== 200) {
      toast.error(res?.data?.message);
    }
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => (
    <Fragment>
      <Button
        onClick={filterToggle}
        className="filter-hamburger filter-btn btn btn-transparent"
      >
        <img src={Images?.Filter} alt="" />
        {localization.showFilters}
      </Button>
    </Fragment>
  );

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    const res = await getoffRoleEmployeesData(
      val.selected + 1,
      [5, 2],
      null,
      filter
    );
    if (res?.data?.response_status !== 200) {
      toast.error(res?.data?.message);
    }
    localStorage.setItem("page", val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.offroleEmployee}
      Buttons={headerBtns}
      className={false ? "requiredFileds" : ""}
      // isGoback
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isId={false}
        detailList={
          getEmployeesListing &&
          getEmployeesListing?.response &&
          getEmployeesListing?.response?.data &&
          getEmployeesListing?.response?.data?.data
        }
        srNo={getEmployeesListing?.response?.data?.from}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        getDropdownDatas={getDropdownDatas}
        offroleEmployeeFilter={true}
      />
    </Layout>
  );
};

export default ApproveRejectList;
